import React from 'react';
import './SummerYouthProgram.css';

const SummerYouthProgram = () => {
  return (
    <main className="summer-program-page">
      <div className="summer-program-container">
        <section className="program-hero">
          <h1 className="program-title">Youth Supporting Roots</h1>
          <p className="program-subtitle">Generations Working Together</p>
        </section>
        
        <section className="program-content">
          <h2 className="section-title">Summer Youth Program</h2>
          
          <div className="program-description">
            <p>
              Youth Supporting Roots is looking for Durham Public School students aged 14 to 16 who are interested in 
              community service through food pantry management. Participants will learn about the business operations from 
              the ground up and receive mentorship from adult volunteers, fostering a mutually enriching relationship between 
              the generations. Interested individuals are encouraged to{' '}
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfHosbezjLxEvIJEI0gMcEZppNqT6OSerX_VvLuF_P-lPn3Wg/viewform?usp=sharing" target="_blank" rel="noopener noreferrer" className="apply-link">click here to fill out the application online</a>, or you can
              also <a href="/download-application-package.pdf" target="_blank" rel="noopener noreferrer" className="download-link">download the application</a> to print.
            </p>
          </div>

          <div className="program-info-section">
            <h3 className="info-title">Youth Supporting Roots Summer 2026 information:</h3>
            
            <ul className="program-details">
              <li>The deadline for application is the 3rd Saturday of May @ 11:59PM.</li>
              <li>Selected participants will receive a welcome note confirming their acceptance. A 4-week schedule, on or by May 31st, 2026.</li>
              <li>This summer session will take place from June 12th – August 4th, 2026.</li>
              <li>Participants are expected to serve a maximum of 24 hours a week at local food pantries, the YSR office, or virtually.</li>
              <li>The service week runs from Sunday through Saturday.</li>
              <li>A stipend of $ 1,728 will be provided for the entire eight weeks of service.</li>
            </ul>
          </div>

          <div className="duties-section">
            <h3 className="duties-title">Student duties and expectations:</h3>
            
            <ul className="duties-list">
              <li>Be punctual</li>
              <li>Greet customers and staff</li>
              <li>Work as part of a team, and independently as required</li>
              <li>Dress in appropriate attire*</li>
              <li>Follow safety procedures</li>
              <li>Perform other duties as needed, according to site manager or designee</li>
              <li>(be able to pick up 50 lbs and stand for four hours)</li>
            </ul>
            
            <p className="dress-code">
              <strong>*Dress code:</strong> closed-toed shoes, YSR tee shirt, knee-length skirt or slacks
            </p>
          </div>

          <div className="documents-section">
            <h3 className="documents-title">Necessary documents for applicants:</h3>
            
            <p className="documents-intro">
              In order to process your application, you will need the following documents:
            </p>
            
            <ul className="documents-list">
              <li>A <a href="https://www.labor.nc.gov/workplace-rights/youth-employment-rules/apply-youth-employment-certificate" target="_blank" rel="noopener noreferrer" className="document-link">work permit</a> (follow the link for details of the process)</li>
              <li>An informational <a href="https://drive.google.com/file/d/1J9l723iMY71SJWSSCZYFGxlaHqcsSqJf/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="document-link">questionnaire</a> (to download and print)</li>
              <li><a href="https://drive.google.com/file/d/1xuvfejvnsnzU0bRiRBZTTzncMNYOViXa/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="document-link">Two letters of referral</a> from people who are not family members</li>
            </ul>
            
            <p className="mail-instruction">
              <strong>Please mail these documents to the YSR address, listed below.</strong>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default SummerYouthProgram;
